module.exports = __webpack_public_path__ + "static/media/light.9682a61e.png";